export default __webpack_public_path__ + "static/media/reactlibraries.0003cd15.webp";